module.exports = __webpack_public_path__ + "static/img/avatar-default.ef125b64.png";